/* eslint-disable react-hooks/exhaustive-deps */
import InputForm from "../../../components/inputs/InputForm";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Col, Row } from "react-bootstrap";
import { Loader, toaster } from "rsuite";
import { useEffect, useState } from "react";
import InputSearch from "../../../components/inputs/InputSelectSearch";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import peticionBack from "../../../libs/peticiones/peticionBack";
import { Area } from "../../../types/compl-archivos/Area";
import { Instancia } from "../../../types/compl-archivos/Instancia";
import { Distrito } from "../../../types/compl-archivos/Distrito";
import { Region } from "../../../types/compl-archivos/Region";

const defaultForm: Area = {
    instance: "",
    district: "",
    name: "",
    area_key: "",
    p_area: "",
    email: "",
};

const formSchema = Yup.object().shape({
    instance: Yup.string().required("Seleccione una instancia"),
    district: Yup.string().required("Seleccione un distrito"),
    name: Yup.string().required("Ingrese un nombre"),
    // area_key: Yup.string().required("Ingrese una clave de área"),
    // email: Yup.string()
    //   .required("Ingrese un correo electrónico")
    //   .email("Ingrese un correo electrónico valido"),
});

export default function Form({ setOpen, selected, instancias }: { setOpen: any; selected?: Area; instancias: Instancia[] }) {
    const [loading, setLoading] = useState<boolean>(true);
    const [distritos, setDistritos] = useState<any>([]);
    const [areas, setAreas] = useState<Area[]>([]);

    useEffect(() => {
        getAreas();
        getDistritos();
    }, []);

    async function getAreas() {
        const res = await peticionBack({}, "/areas", "GET", false, toaster);
        if (res) setAreas(res.data);
        setLoading(false);
    }

    const { handleSubmit, handleReset, handleBlur, setFieldValue, setValues, values, errors, touched } = useFormik({
        initialValues: defaultForm,
        validationSchema: formSchema,
        onSubmit: (values) => {
            swalAction(save, `${selected ? "Editar" : "Guardar"} Área`, `¿Desea ${selected ? "editar" : "guardar"} esta área?`, "question");
        },
        onReset: () => {
            setOpen(false);
        },
    });

    function onChange({ target }: { target: any }) {
        setFieldValue(target.name, target.value);
    }

    async function getDistritos() {
        const res = await peticionBack({}, `/distritos`, "GET", false, toaster);
        if (res) {
            setDistritos(res.data);
        }
        setLoading(false);
    }

    useEffect(() => {
        if (selected) {
            setValues(
                {
                    instance: (selected.instance as Instancia)._id as string,
                    district: (selected.district as Distrito)._id as string,
                    name: selected.name,
                    area_key: selected.area_key,
                    p_area: (selected.p_area as Area)?._id || "",
                    email: selected.email,
                    region: (selected.district as Distrito).region as string,
                },
                true,
            );
        }
    }, []);

    async function save() {
        const method = selected ? "PUT" : "POST";
        const rute = selected ? `/${selected._id}` : "";
        setLoading(true);
        const params: any = { ...values };
        if (!values.p_area) delete params.p_area;
        if (!values.email) delete params.email;
        const res = await peticionBack(params, "/areas" + rute, method, true, toaster);
        if (res) handleReset(null);
        setLoading(false);
    }

    return (
        <form onSubmit={handleSubmit} onReset={handleReset}>
            <Row>
                <Col xs={12} md={6}>
                    <InputForm label="Nombre área" name="name" type="text" value={values.name} touched={touched.name} error={errors.name} onChangeMethod={onChange} onBlurMethod={handleBlur} required />
                </Col>
                <Col xs={12} md={6}>
                    <InputForm label="Clave" name="area_key" type="text" value={values.area_key} touched={touched.area_key} error={errors.area_key} onChangeMethod={onChange} onBlurMethod={handleBlur} />
                </Col>
                <Col xs={12} md={6}>
                    <InputForm label="Correo" name="email" type="text" value={values.email} touched={touched.email} error={errors.email} onChangeMethod={onChange} onBlurMethod={handleBlur} />
                </Col>
                <Col xs={12} md={6}>
                    <InputSearch label="Área" name="p_area" value={values.p_area as string} touched={touched.p_area} error={errors.p_area} values={areas} labelVal="name" valueVal="_id" onChangeMethod={onChange} onBlurMethod={handleBlur} />
                </Col>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Instancia"
                        name="instance"
                        value={values.instance as string}
                        touched={touched.instance}
                        error={errors.instance}
                        values={instancias}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                    />
                </Col>
                <Col xs={12} md={6}>
                    <InputSearch
                        label="Distritos"
                        name="district"
                        value={values.district as string}
                        touched={touched.district}
                        error={errors.district}
                        values={distritos}
                        labelVal="name"
                        valueVal="_id"
                        onChangeMethod={onChange}
                        onBlurMethod={handleBlur}
                        required
                    />
                </Col>
            </Row>

            <div className="d-grid gap-2 d-md-flex justify-content-md-around mt-2">
                <Button variant="danger" type="reset">
                    Cancelar
                </Button>
                <Button variant="success" type="submit">
                    Guardar
                </Button>
            </div>

            {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
        </form>
    );
}
